module.exports = __webpack_public_path__ + "img/child-marriage.b37cff82.png";